export interface SignalrHubAuthenticationResponse {
	url: string;
	accessToken: string;
}

export interface SignalrChangeMessage<TPayload = unknown> {
	payload: TPayload;
	type: SignalrChangeType;
}

export enum SignalrChangeType {
	Added = 1,
	Updated = 2,
	Deleted = 3,
	Error = 4,
}
